import {Button, Modal} from '@goproblems/ui';

import {hideModal, MODAL_PROBLEM_STARS, useSelector} from '@utils';
import {useTranslation} from 'react-i18next';
import {useFetchProblemStarsQuery} from '@api';
import {Loading, ProblemStarsTable} from '@components';

export const ProblemStarsModal = ({
    problemId,
    name = MODAL_PROBLEM_STARS,
}: {
    problemId: number;
    name?: string;
}) => {
    const show = useSelector(s => s.modalProblemStars);
    const {t} = useTranslation();
    const {data: starsData, isLoading} = useFetchProblemStarsQuery(problemId, {
        refetchOnMountOrArgChange: true,
        skip: !show,
    });

    const handleClose = () => {
        hideModal(name);
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            dialogClassName="md:max-w-fit md:!min-w-160">
            <Modal.Header closeButton>
                <Modal.Title>{t('problem.problem_stars')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading && <Loading />}
                {!isLoading && starsData?.entries && (
                    <ProblemStarsTable stars={starsData?.entries} />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t('common.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
